import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { RowCell, GridCell, ContentElement } from '../../../models/sections-model';

@Component({
  selector: 'kve-feature-cell-content',
  templateUrl: './feature-cell-content.component.html',
  styleUrls: ['./feature-cell-content.component.scss']
})
export class FeatureCellContentComponent implements OnChanges{
  @Input() cell:RowCell|GridCell;
  @Input() preview:boolean;
  contentElements:ContentElement[];


  ngOnChanges(changes: SimpleChanges): void {
    if(changes["cell"]){
      this.contentElements = this.cell.contentElements
    }
  }

  onUpdateContent(){}

}
